import {
  createContext,
  useState,
  useMemo,
  useContext,
} from "react";

/**
 * Context for dispatch/job-report capture loading state.
 */
export const CaptureContext = createContext(null);

/**
 * Reads CaptureContext. Throws if used outside a Capture provider.
 *
 * @returns {Object} Capture context value.
 */
export function useCaptureContext() {
  const context = useContext(CaptureContext);
  if (!context) {
    throw new Error("useCaptureContext must be used within a CaptureProvider");
  }
  return context;
}

/**
 * Builds capture context: whether a capture-target component is mounted.
 *
 * @returns {{captureComponent: boolean, setCaptureComponent: Function}} Capture state.
 */
export function useCaptureCtx() {
  // Global loading state
  const [captureComponent, setCaptureComponent] = useState(true);
  
  const contextValue = useMemo(
    // Memo so if another component calls it doesn't re-run context unless changed
    () => ({
      captureComponent,
      setCaptureComponent,
    }),
    [
      captureComponent,
      setCaptureComponent,
    ]
  );

  return {
    ...contextValue,
  };
}

export default useCaptureCtx; // Export the hook as default for backward compatibility
